export default "<div class=\"typeacces\">\n  {{ FormeJuridiqueInComponent.Identifiant }}\n</div>";